import { Controller } from "@hotwired/stimulus"
import Mustache from 'mustache'

export default class extends Controller {
  static values = {
    requestUrl: String
  }
  connect() {
    const parsedItems = this.parseFinancialItemsCookie()
    if(parsedItems != null){
      const codes = parsedItems.map((obj) => {
        return obj.stock_code
      })
      this.getAndParseStocks(this.requestUrlValue + "?codes=" + codes.join(','))
    }
  }

  async getAndParseStocks(requestUrl){
    const mcTemplate = document.getElementById('recentlyVisitedStocksTemplate')
    const response = await fetch(requestUrl)
    const stockData = await response.json()
    if(response.ok){
      const templateStocks = stockData.items.map((item) => {
        let tStc = {}
        tStc.code = item.financial_item.code
        tStc.name = item.financial_item.name
        tStc.price = item.d_price
        tStc.comparePrice = item.d_change
        let dChange = Number(item.d_change)
        if(dChange > 0.0){
          tStc.compareClass = 'text-red-700'
        }else{
          tStc.compareClass = 'text-itf-blue-positive'
        }
        return tStc
      })
      const tableHTML = Mustache.render(mcTemplate.innerHTML, {stocks: templateStocks.slice(0, 10)})
      this.element.innerHTML = tableHTML
    }
  }

  getCookieValue(cookieName) {
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i].trim();
          if (cookie.startsWith(cookieName + '=')) {
              return cookie.substring(cookieName.length + 1);
          }
      }
      return null;
  }

  parseFinancialItemsCookie() {
      const cookieValue = this.getCookieValue('recent_browsed_financial_items');
      if (cookieValue) {
          try {
              return JSON.parse(decodeURIComponent(cookieValue));
          } catch (error) {
              return null;
          }
      }
      return null;
  }
}
